import React from 'react';
import './header.css'
import logo from '../../assets/logo.png'
import Navsheader from '../common/navs-header';
import pic1 from '../../assets/pic1.png'
import pic2 from '../../assets/pic2.png'
import pic37 from '../../assets/pic37.png'
 import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const Header = () => {

    const { t, i18n } = useTranslation();

    const [locale,setLocale]=useState('ar')
const isArabic = i18n.language === 'ar';
    function handlelanguageclick(){
      if (locale==='en'){ setLocale('ar')
         i18n.changeLanguage('ar')
      } else{setLocale('en')
        i18n.changeLanguage('en')
      }
   
    }





  const [burgerOpen, setBurgerOpen] = useState(false);




    return ( 
        <header className='header' dir={locale === 'ar' ? 'rtl' : 'ltr'}>
            <nav className='header-container-sec1'>
                <img className='logo-header'   src={isArabic ? pic37 : logo}  alt="logo" />


                <ul className="navigations-header-container">
                    <Navsheader title={t('Home')} />
                    <Navsheader  title={t('Events')}  />
                    <Navsheader  title={t('Book Now')} />
                    <Navsheader title={t('Contact Us')} />
                    <button className='cta-header' onClick={handlelanguageclick}>
                        <img src={pic1} alt='lang'></img>
                       <h2 className='lang'>{locale === "en" ? "عربي" : "ENG"}</h2>
                    </button>
                </ul>


                             <img
          src={pic2}
          alt="burger menu"
          className="burger-btn"
          onClick={() => setBurgerOpen(!burgerOpen)}
        />

        {burgerOpen && (
          <ul className="burger-menu">
            <Navsheader title={t('Home')} />
            <Navsheader title={t('Events')} />
            <Navsheader  title={t('Book Now')} />
            <Navsheader title={t('Contact Us')}/>

         <button className="cta-header" onClick={handlelanguageclick}>
    <img src={pic1} alt="lang" />
    <h2 className="lang">{locale === "en" ? "عربي" : "ENG"}</h2>
</button>
          </ul>
        )}
            </nav>
        </header>
     );
}
 
export default Header;